import styled from 'styled-components'
import { IconButton } from '@mui/material';

import {ReactComponent as Reverse} from "images/reverse.svg";
import {ReactComponent as Filter} from "images/filter.svg";
import {ReactComponent as ClearSvg} from "images/clearFilter.svg";

export const Page = styled.div`
  height: 100%;
  background-color: white;
  overflow: auto;
  font-family: var(--fontMain, Poppins), sans-serif;
`

export const Container = styled(Page)`
  width: 100%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;

  @media (min-width: 1200px) {
    max-width: 900px;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .backButtonRow {
    padding: 0.75rem 0 0.25rem;
  }

  .backButton {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.25rem 0;
    background: transparent;
    border: 0;
    color: var(--primary-blue, #0B4598);
    font-family: var(--fontMain, Poppins), sans-serif;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    svg {
      font-size: 1.25rem;
    }

    &:hover {
      text-decoration: underline;
    }

    &:active {
      color: #072f6b;
    }
  }

  .subtitle {
    font-family: var(--fontMain, Poppins), sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    padding: 1rem;
  }
  .favFilter {
    font-family: var(--fontMain, Poppins), sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 0.875rem;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 0.25rem 1rem;
    border-bottom: 1px solid #E6E8EC;
    min-width: 0;

    .shiftTabs {
      display: flex;
      align-items: flex-end;
      gap: 1.25rem;
      min-width: 0;
    }

    .favButton {
      color: #6D6D72;
      padding: 0.5rem 0;
      white-space: nowrap;
      cursor: pointer;
    }
    .underlined {
      border-bottom: 2px solid var(--primary-blue, #0B4598);
      height: fit-content;
      color: #05132E;
    }
  }

  .filter-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem 0.875rem;

    button {
      color: var(--primary-blue, #0B4598);
      border: none;
      background: transparent;
      padding: 0.5rem 0;
      font-family: var(--fontMain, Poppins), sans-serif;
      font-weight: 600;
      font-size: 0.75rem;
      cursor: pointer;
      white-space: nowrap;
    }

    button:hover:not(:disabled), .unhideShifts:hover { text-decoration: underline; }

    .action-previous.disabled {
      color: #9AA4B2;
      cursor: not-allowed;
      opacity: 1;
    }
    .unhideShifts {
      color: var(--primary-blue, #0B4598);
      font-size: 0.75rem;
      padding: 0.5rem 0;
    }
  }

  .filteringBox {
    padding: 0.5rem 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.375rem 0.625rem;
    min-width: 0;

    .filterDivider {
      width: 1px;
      height: 22px;
      background: #D8DDE5;
      flex: 0 0 auto;
    }

    .filterChips {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.375rem;
      min-width: 0;
    }

    .filterButton {
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
      padding: 5px 9px;
      border: 1px solid #D8DDE5;
      border-radius: 999px;
      white-space: nowrap;
      color: #05132E;
      font-family: var(--fontMain, Poppins), sans-serif;
      font-size: 0.75rem;
      transition: background-color 0.2s ease, border-color 0.2s ease;
      cursor: pointer;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
      touch-action: manipulation;
      position: relative;

      &::after {
        content: '';
        width: 5px;
        height: 5px;
        margin: -3px 2px 0 1px;
        border-right: 1.5px solid currentColor;
        border-bottom: 1.5px solid currentColor;
        transform: rotate(45deg);
      }

      &:hover {
        background-color: rgba(11, 69, 152, 0.03);
      }

      &:active {
        background-color: rgba(11, 69, 152, 0.08);
      }

      &.active {
        border-color: var(--primary-blue, #0B4598);
        background-color: rgba(11, 69, 152, 0.06);
      }
    }
  }

  @media (max-width: 600px) {
    .favFilter { justify-content: flex-start; }
    .shiftTabs { width: 100%; }
    .filter-actions { justify-content: flex-start; }
    .filteringBox .filterDivider { display: none; }
  }

  @media (max-width: 380px) {
    .filteringBox .filterChips { gap: 0.25rem; }
    .filteringBox .filterButton {
      gap: 0.125rem;
      padding: 5px 5px;
      font-size: 0.6875rem;
    }
  }

  /* Simple section header and spacer utilities */
  .sectionTitle {
    font-family: var(--fontMain, Poppins), sans-serif;
    font-weight: 600;
    margin: 12px 4px 4px;
    color: var(--primary-blue, #0B4598);
  }
  .sectionSpacerSmall { height: 8px; }
`

export const Icon = styled.img`
  align-self: stretch;
  object-fit: contain;
  margin-right: 3px;
  font-size: 1rem;
  line-height: 1.375rem;
  & path {
    fill: #13CA82;
  }
`;

export const SVG = styled.svg`
  width: ${({width}) => width};
  & path {
    fill: ${({color}) => color};
  }

  &:hover path {
    fill: ${({color}) => color};
  }
`

export const ReverseSVG = styled(Reverse)`
  width: ${({width}) => width};
  pointer-events: none;
  flex-shrink: 0;
  & path {
    fill: ${({color}) => color};
  }

  &:hover path {
    fill: ${({color}) => color};
  }
`

export const FilterSVG = styled(Filter)`
  width: ${({width}) => width};
  & path {
    fill: ${({color}) => color};
  }

  &:hover path {
    fill: ${({color}) => color};
  }
`

export const ClearSVG = styled(ClearSvg)<{hidden?: boolean}>`
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
  width: 12px;
  height: 12px;
  margin-left: ${({ hidden }) => (hidden ? '0' : 'auto')};
  flex-shrink: 0;
  cursor: pointer;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  pointer-events: ${({ hidden }) => (hidden ? 'none' : 'auto')};

  & path {
    stroke: #BDBDBD;
  }
  &:hover path {
    stroke: #D93829; /* TempStars red */
  }
`;

export const FeaturedHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--fontMain, Poppins), sans-serif;
  font-weight: 600;
  margin: 12px 4px 4px;
  color: var(--primary-blue, #0B4598);
`;

export const FeaturedInfoButton = styled(IconButton)`
  && {
    color: var(--primary-blue, #0B4598);
    padding: 0;
  }
`;
